import { useEffect, useState } from 'react';

import { Svg_Icone_User, Svg_LogoTipo } from '../Svg';

import './Header.css';

import { GetStatusGlobal, RegisterStatusGlobal, UnRegisterStatusGlobal } from '../../interface/Global';

export default function Comp_Header() {

    const [ userName, setUserName ] = useState<string>(GetStatusGlobal('user_name') as string);
    const [ userFile, setUserFile ] = useState<string>(GetStatusGlobal('user_file') as string);

    useEffect(() => {
        const handleName = (value: boolean | string | number) => setUserName(value as string);
        const handleFile = (value: boolean | string | number) => setUserFile(value as string);

        RegisterStatusGlobal('user_name', handleName);
        RegisterStatusGlobal('user_file', handleFile);

        return () => {
            UnRegisterStatusGlobal('user_name', handleName);
            UnRegisterStatusGlobal('user_file', handleFile);
        };
    }, []);

    return(
        <div className="Comp_Header">
            <div className="div_logo">
                <Svg_LogoTipo className="" />
                <div className="">THE REAL ESTATE PLATFORM</div>
            </div>
            <div className="inf_login">
                {
                    userFile ?
                        <div className="img_user" style={ { backgroundImage: 'url("' + userFile + '")' } } />
                    :
                    <Svg_Icone_User className="icons" color="#ffffff" />
                }
                <div className="name_user">
                    { userName?.split(' ')[0] }
                </div>
            </div>
        </div>
    )
}
